import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { enterprisePlans } from '../../../../../shared/subscriptions/consts';
import RouterLink from '../../../generic/Link/RouterLink';
import { getFeatureDetails } from '../../billing/features/consts';
import type { FossaPlanName } from '../../../../../shared/subscriptions/consts';
import type { FeatureDescription, MessageOptions } from '../../billing/features/consts';

import PlanCards from './PlanCards';
import PlansHeader from './PlansHeader';

import styles from './ModalPlans.module.less';

type PlanType = 'Enterprise' | 'Business';

type ModalPlanTitleProps = {
  plan: PlanType;
  feature?: FeatureDescription | null;
};

const ModalPlanTitle: VoidFunctionComponent<ModalPlanTitleProps> = ({
  plan,
  feature,
}: ModalPlanTitleProps) => {
  if (feature) {
    if (enterprisePlans.includes(plan as FossaPlanName)) {
      return (
        <>
          <strong>{feature.name}</strong>
          {' '}
          available with an <strong>Enterprise</strong> plan
        </>
      );
    }

    return (
      <>
        <strong>{feature.name}</strong>
        {' '}
        available with an <strong>Business</strong> plan
      </>
    );
  }

  if (plan === 'Enterprise') {
    return <>Available with an <strong>Enterprise</strong> plan</>;
  }

  return <>Available with a <strong>Business</strong> plan</>;
};

type ModalPlansProps = {
  onHide: () => void;
  isShowing: boolean;
  messageOptions?: MessageOptions;
};

const ModalPlans: VoidFunctionComponent<ModalPlansProps> = ({
  onHide,
  isShowing,
  messageOptions,
}: ModalPlansProps) => {
  const featureDetails = getFeatureDetails(messageOptions?.focusFeature);

  return (
    <Modal
      show={isShowing}
      onHide={onHide}
      dialogClassName={styles.planSelectorModalContainer}
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <div className={styles.title}>
          <ModalPlanTitle plan={messageOptions?.tier as PlanType} feature={featureDetails} />
        </div>
        <PlansHeader hideLabel />
        <PlanCards />
        <div className={styles.viewPlanDetails}>
          <RouterLink
            className={styles.fullPlanDetailsLink}
            onClick={onHide}
            to="/account/settings/billing?tab=Plans"
          >
            View Full Plan Details
          </RouterLink>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPlans;
